const INCIDENTS_URL = 'https://status.transfeera.com/api/v2/incidents.json';

export default {
  get: () => fetch(INCIDENTS_URL, {}).then(resp => resp.json())
};
